import { Toaster as SonnerToaster, toast } from 'sonner';

// Re-export the global imperative `toast` API alongside the themed Toaster
// component so callers have a single shared/ui import path. react-refresh
// requires a comment to allow the non-component re-export.
/* eslint-disable react-refresh/only-export-components */
export { toast };
/* eslint-enable react-refresh/only-export-components */

/**
 * Project-themed wrapper around sonner's <Toaster>. Mounted once at the app
 * root. Use the re-exported `toast` API (toast.success/error/info/...) from
 * anywhere — no provider needed, sonner is global.
 */
export function Toaster(): React.JSX.Element {
  return (
    <SonnerToaster
      position="top-center"
      theme="dark"
      richColors
      closeButton
      offset="env(safe-area-inset-top, 0)"
      toastOptions={{
        classNames: {
          toast: 'bg-card border-border text-foreground',
        },
      }}
    />
  );
}
